import React from 'react';
import style from './style.module.scss';

const SportsTypeImage = ({sportsType, width, height}) => {
  return (
    <div
      className={style.sports_type_image}
      style={{ width: width, height: height }}
    >
      <div className={style[sportsType]} />
    </div>
  );
};

export default SportsTypeImage;
